export default __webpack_public_path__ + "static/media/hero_video.bc9879cf.MP4";